export const GET_ITR_COMPLIANCE_RESULT = "GET_ITR_COMPLIANCE_RESULT";
export const GET_ITR_COMPLIANCE_RESULT_LOADING = "GET_ITR_COMPLIANCE_RESULT_LOADING";
export const GET_ITR_COMPLIANCE_RESULT_SUCCESS = "GET_ITR_COMPLIANCE_RESULT_SUCCESS";
export const GET_ITR_COMPLIANCE_RESULT_ERROR = "GET_ITR_COMPLIANCE_RESULT_ERROR";
export const CLEAR_ITR_COMPLIANCE_RESULT = "CLEAR_ITR_COMPLIANCE_RESULT";

export const getItrResult = (body) => ({ type: GET_ITR_COMPLIANCE_RESULT, body });

export const clearItrResult = () => ({ type: CLEAR_ITR_COMPLIANCE_RESULT, data: {} });
